import React, { useState, useEffect } from "react";
import moment from "moment";

import { Row, Column } from "components/Layout";
import Checkbox from "components/Checkbox";
import ElementModal from "./ElementModal";
import style from './_modal.module.scss';


export default function PhenologyPeriodModal({ isOpen, onClose, onSubmit, item }) {
	const [startDate, setStartDate] = useState(new Date())
	const [confirmed, setConfirmed] = useState(true)
	const [cascade, setCascade] = useState(false)

	useEffect(() => {
		setStartDate(item.startDate)
		setConfirmed(true)
		setCascade(false)
	}, [item])

	function submit() {
		onSubmit(item.id, startDate, confirmed, cascade);
	}

	return (
		<ElementModal isOpen={isOpen} onClose={onClose} submit={submit}>
			<Column className={style.section}>
				<Row className={style.title}>
					{item.phenologicalPhase?.label}
				</Row>
				<Row className={style.fields}>
					{"Data inizio"}
					<input
						type="date"
						value={startDate}
						min={moment(item.startDate, 'YYYY-MM-DD').startOf('year').format('YYYY-MM-DD')}
						max={moment(item.startDate, 'YYYY-MM-DD').endOf('year').format('YYYY-MM-DD')}
						onChange={e => setStartDate(e.target.value)}
						required
					/>
				</Row>
				<Row className={style.fields}>
					{'Conferma'}
					<Checkbox
						checked={confirmed}
						onCheck={(e) => setConfirmed(e.target.checked)}
					/>
				</Row>
				<Row className={style.fields}>
					{'Applica a cascata'}
					<Checkbox
						checked={cascade}
						onCheck={(e) => setCascade(e.target.checked)}
					/>
				</Row>
			</Column>
		</ElementModal>
	)
}
